import { PowerUnit } from '../enums'
import { Generator } from '../types'
import {
  convertKilovoltAmperesToAmperes,
  convertKilovoltAmperesToKilowatts,
  convertKilovoltAmperesToWatts,
  convertKilowattsToAmperes,
  convertKilowattsToKilovoltAmperes,
  convertKilowattsToWatts
} from './convert'

export const getGeneratorName = (generator: Generator) => {
  return generator?.customerReference !== null && generator.customerReference !== ''
    ? generator.customerReference
    : `${generator.apparentPower} kVA`
}

export const calculateNominalCurrent = (generator: Generator) => {
  const isSiglePhase = generator.nominalVoltage <= 230

  if (isSiglePhase) {
    return (generator.apparentPower * 1000) / generator.nominalVoltage
  } else {
    return (generator.apparentPower * 1000) / (Math.sqrt(3) * generator.nominalVoltage)
  }
}

export const isSinglePhase = (generator: Generator) => {
  return generator.nominalVoltage <= 230
}

export const convertApperentPower = (generator: Generator, unit = PowerUnit.KILOVOLT_AMPERE) => {
  const kilovoltAmperes = generator.apparentPower
  const voltage = generator.nominalVoltage
  const powerFactor = 1

  switch (unit) {
    case PowerUnit.AMPERE:
      return convertKilovoltAmperesToAmperes(kilovoltAmperes, voltage)

    case PowerUnit.KILOWATT:
      return convertKilovoltAmperesToKilowatts(kilovoltAmperes, powerFactor)

    case PowerUnit.WATT:
      return convertKilovoltAmperesToWatts(kilovoltAmperes, powerFactor)

    case PowerUnit.KILOVOLT_AMPERE:
    default:
      return kilovoltAmperes
  }
}

export const convertAdditionalLoad = (generator: Generator, unit = PowerUnit.KILOWATT) => {
  if (generator?.customData?.additionalLoad === undefined) {
    return null
  }

  const kiloWatts = generator.customData.additionalLoad
  const voltage = generator.nominalVoltage
  const powerFactor = 1

  switch (unit) {
    case PowerUnit.AMPERE:
      return convertKilowattsToAmperes(kiloWatts, voltage, powerFactor)

    case PowerUnit.KILOVOLT_AMPERE:
      return convertKilowattsToKilovoltAmperes(kiloWatts, powerFactor)

    case PowerUnit.WATT:
      return convertKilowattsToWatts(kiloWatts)

    case PowerUnit.KILOWATT:
    default:
      return kiloWatts
  }
}
